import React from 'react';
import { connect } from 'react-redux';
import { obterTutorial, salvarTutorial } from '../actions/TutorialActions';

class Videos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tutorial: {
        contrato: '',
        formandos: '',
        itens: '',
        entrega: '',
        edicao: '',
        aprovacao: '',
      },
    };
  }

  componentWillMount() {
    this.props.obterTutorial();
  }

  componentWillReceiveProps(props) {
    if (props.tutorial) {
      this.setState({ tutorial: props.tutorial });
    }
  }

  salvarMudancas(event) {
    event.preventDefault();
    this.props.salvarTutorial(this.state.tutorial);
  }

  alterarForm(event) {
    const campo = event.target.name;
    const tutorial = this.state.tutorial;
    tutorial[campo] = event.target.value;
    return this.setState({ tutorial });
  }

  render() {
    return (
      <div>
        <div className='callout callout-success'>
          <h4>Importante!</h4>
          <p>
            Os links devem ser do youtube com formanto "embutido". Para isso,
            acesse o vídeo no youtube, clique em compartilhar, em seguida
            incorporar, copie apenas o campo "src" do texto que for fornecido.
          </p>
        </div>
        <div className='box '>
          <form
            className='form-horizontal'
            onChange={this.alterarForm.bind(this)}
            onSubmit={this.salvarMudancas.bind(this)}
          >
            <div className='box-body'>
              <div className='form-group'>
                <label htmlFor='contrato' className='col-sm-3 control-label'>
                  Tela contrato
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='contrato'
                    value={this.state.tutorial.contrato}
                    className='form-control'
                    id='contrato'
                    placeholder=''
                  />
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='formando' className='col-sm-3 control-label'>
                  Tela cadastrar formando
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='formandos'
                    value={this.state.tutorial.formandos}
                    className='form-control'
                    id='formando'
                    placeholder=''
                  />
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='itens' className='col-sm-3 control-label'>
                  Tela distribuir itens
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='itens'
                    value={this.state.tutorial.itens}
                    className='form-control'
                    id='itens'
                    placeholder=''
                  />
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='entrega' className='col-sm-3 control-label'>
                  Tela informações de entrega
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='entrega'
                    value={this.state.tutorial.entrega}
                    className='form-control'
                    id='entrega'
                    placeholder=''
                  />
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='edicao' className='col-sm-3 control-label'>
                  Tela edição do formando
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='edicao'
                    value={this.state.tutorial.edicao}
                    className='form-control'
                    id='edicao'
                    placeholder=''
                  />
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='aprovacao' className='col-sm-3 control-label'>
                  Tela aprovação do convite
                </label>
                <div className='col-sm-8'>
                  <input
                    type='text'
                    name='aprovacao'
                    value={this.state.tutorial.aprovacao}
                    className='form-control'
                    id='aprovacao'
                    placeholder=''
                  />
                </div>
              </div>
            </div>
            <div className='box-footer'>
              <button
                type='submit'
                className='btn btn-success btn-flat pull-right'
              >
                Salvar mudanças
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tutorial: state.tutorial.tutorial,
  };
};

export default connect(mapStateToProps, { obterTutorial, salvarTutorial })(
  Videos
);



// WEBPACK FOOTER //
// ./src/views/Videos.js